import { render, staticRenderFns } from "./modal-info.vue?vue&type=template&id=72e2d3d0"
import script from "./modal-info.vue?vue&type=script&lang=js"
export * from "./modal-info.vue?vue&type=script&lang=js"
import style0 from "./modal-info.vue?vue&type=style&index=0&id=72e2d3d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports